module.exports = __webpack_public_path__ + "static/egyptian-cotton-duvet-cover-navy-1-f6afedfce87615ec4bf11c621a781711.webp";